$.validator.addMethod(
	"regex",
	function(value, element, regexp) {
		var re = new RegExp(regexp);
		return this.optional(element) || re.test(value);
	},
	"Поле заполнено неверно"
);

class InteractiveForm {
	constructor(el, opts = {}) {
		this.$form = $(el);
		console.log($form)
		let $form = this.$form;

		$form.on("submit", function(e) {
			e.preventDefault();
		});

		if ($form.data("action")) {
			$form.prop("action", $form.data("action"));
		}

		$form.find('[name="phone"]').inputmask({
			mask: '+7 999 999-99-99',
			placeholder: 'x',
			showMaskOnHover: false
		});

		$form.on('focus', 'input', function (e) {
			$(e.currentTarget).siblings('.RequestForm_lbl').addClass('_active');
		});

		$form.on('focusout', 'input', function (e) {
			if ($(e.currentTarget).val() == '') {
				$(e.currentTarget).siblings('.RequestForm_lbl').removeClass('_active');
			}
		})


		let validatorOpts = {
			rules: {
				phone: {
					required: true,
					regex: /\+7\s\d\d\d\s\d\d\d\-\d\d\-\d\d/
				}
			},
			errorElement: "em",
			onfocusout: (el, event) => {
				$(el).valid();
			},

			onclick: false,
			focusCleanup: false,
			submitHandler: opts.submitHandler || this.standartFormHandler, //(form)=>{}
			// errorPlacement: (/*$errorLabel, $el*/) => {
			// 	return true;
			// }
			errorPlacement: ($errorLabel, $el) => {
				if ($el.attr('name') === "agree") {
					return true;
				} else {
					$errorLabel.addClass('Form_hint Form_hint-error');
					$el.parent().append($errorLabel);
					return true;
				}
			},
		};

		if (opts.validatorParams) {
			$.extend(true, validatorOpts, opts.validatorParams);
		}

		if (opts.successBlockMod) {
			$.extend(true, opts, { successBlockMod: "default" });
		}

		this.opts = opts;
		this.validator = $form.validate(validatorOpts);
	}

	standartFormHandler(form) {
		// console.log('form', form)
		let $form = $(form);
		// window.pagePreloader.show();

		let dataToSend = $.extend(true, $form.serializeObject(), {
			Submit: 1,
			url: window.location.href
		});

		console.log('form.method', form.method)

		$.ajax({
			url: form.action,
			type: form.method,
			data: dataToSend,
			success: function(response) {
				let errorCode = parseInt(response.code);

				if (errorCode === 0) {
					let successText;
					let type = form.dataset.formType;

					console.log('type', type)

					switch (type) {
						case 'request':
							successText = `<div class="FormSuccess"><div class="FormSuccess_text ">
								<div class="FormSuccess_title">Готово!</div>
								${response.success}
								</div></div>`;

							window.requestAnimationFrame(() => {
								$form.parent().html(successText);
							});
							break;
						case 'booking':
							let $tlt  = $form.parent().find('.FlatBooking_tlt');
							let $box  = $form.parent();
							successText = `<div class="FormSuccess _booking">
								<div class="FormSuccess_text ">
									<div class="FormSuccess_title _booking">Заявка отправлена!</div>
								</div>
								<div class="FormSuccess_done">
									<button class="Button _secondary" data-close-popup>Готово</button>
								</div>
								</div>`;

							window.requestAnimationFrame(() => {
								$form.hide().after(successText);
								$tlt.hide();
								$box.addClass('_success');
							});
							break;
						case 'flat-consult':
							let $closeBtn  = $form.parent().find('[data-close-consult]');
							console.log('$closeBtn', $closeBtn)
							successText = `<div class="FormSuccess"><div class="FormSuccess_text ">${
								response.success
								}</div></div>`;

							window.requestAnimationFrame(() => {
								$form.hide().after(successText);
								console.log('this', this)
								$closeBtn.hide();
							});
							break;
                        case 'favorites':
                            $tlt  = $form.parent().find('.FavoriteRequest_tlt');
                            successText = `<div class="FormSuccess _booking">
								<div class="FormSuccess_text ">
									<div class="FormSuccess_title _booking">Список отправлен!</div>
								</div>
								<div class="FormSuccess_done">
									<button class="Button _secondary" data-close-popup>Готово</button>
								</div>
								</div>`;

                            window.requestAnimationFrame(() => {
                                $form.hide().after(successText);
                                $tlt.hide();
                            });
                            break;
						default:
							successText = `<div class="FormSuccess"><div class="FormSuccess_text ">${
								response.success
								}</div></div>`;

							window.requestAnimationFrame(() => {
								$form.hide().after(successText);
							});
					}
					setTimeout(function () {
						$('.FormSuccess').on('click', '.Button[data-close-popup]', function () {
							$.fancybox.close();
						});
					}, 200);
				} else {
					alert("Не удалось отправить форму! Попробуйте позже или обратитесть по телефону...");
				}

				// window.pagePreloader.hide();
			}
		});
	}

	reset() {
		this.$form[0].reset();
	}

	destroy() {
		this.validator.destroy();
		this.$form.find("input").inputmask("remove");
	}
}
